import { ErrorType } from '@enmon/commons';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const TRANSLATED_ERRORS = defineMessages<ErrorType>({
  [ErrorType.CaslForbiddenError]: { id: 'app.common.errors.permissionsError' },
  [ErrorType.Unauthorized]: { id: 'app.common.errors.unauthorizedError' },
  [ErrorType.TooManyDataPoints]: { id: 'app.common.errors.tooManyDataPoints' },
  [ErrorType.PreconditionFailed]: { id: 'app.common.errors.preconditionFailed' },
});
